// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26oAQ","inputWrap":"Table_inputWrap__2NQst","col":"Table_col__2N76s","bmiTooltip":"Table_bmiTooltip__3Sv12"};